import React from 'react'
import './../style/Header.css'
import './../style/Global.css'

import Navbar from './Navbar'
import NavbarMobile from './NavbarMobile'
import BisnessHours from './BusinessHours'

import logo from './../img/logo.png'
import iconToDown from './../img/Rectangle 49.png'

const Header = () => {
  return (
    <header className='header'>
      <Navbar />
      <NavbarMobile />  

      <div className="header-logo-wrapp">
        <img className='logo' src={logo} alt="logo" />

        <div className="work-time-mobile">
          <p className='work-time-text-md' >9:00-22:00</p>
          <p className='work-time-text-sm' >Ежедневно</p>
        </div>

        <div className="d-flex jc-sb mt-145 header-btns-wrapp">
          <button className='bg-green header-btn'>
            <a href="#Office-rules">Записаться</a>
          </button>
          <button className='header-btn check-out'>
            <a href="/">оформить бонусную карту</a>
          </button>
        </div>
        <a href="#Price-list" className='header-link-down'>
          <img src={iconToDown} alt="" />
        </a>        
      </div>

      <BisnessHours />
    </header>
  )
}

export default Header;